<template>
  <el-dialog
    v-if="modal"
    :visible="modal"
    width="500px"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    @close="onModalChange"
  >
    <template #title>
      <div class="header">
        <span>增加线路规则</span>
      </div>
    </template>
    <div class="content">
      <div class="content__item">
        <label>区域选择</label>
        <el-select v-model="editParams.pathId" placeholder="请选择" class="w_100">
          <el-option
            v-for="item in areaList"
            :key="item.pathId"
            :label="item.pathName"
            :value="item.pathId"
          ></el-option>
        </el-select>
      </div>

      <div class="content__item">
        <label>规则名称</label>
        <el-input v-model="editParams.pathName" placeholder="请输入规则名称" />
      </div>

      <div class="content__item">
        <label>规则类型</label>
        <el-select v-model="editParams.pathType" placeholder="请选择">
          <el-option
            v-for="item in getOptions()"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >{{item.label}}</el-option>
        </el-select>
      </div>

      <div class="content__item">
        <label>{{{1:'限速阈值(Km/h)',2:'偏离距离(米)'}[editParams.pathType]}}</label>
        <el-input-number
          v-model="editParams.maxSpeed"
          size="mini"
          style="width:220px"
          :step="1"
          :min="1"
        ></el-input-number>
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <el-button @click="onModalChange(false)">取 消</el-button>
        <el-button type="primary" :loading="isLoading" @click="handleSave">保 存</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { getTreeArea, addPathRule, getPathRuleInfobyId, updatePathRule } from '@/api/getRule.js';
import PhotoParam from '@/components/PhotoParamCard';
import moment from 'dayjs';

export default {
  name: "AddLineRule",
  components: {
    PhotoParam
  },
  model: {
    prop: 'modal',
    event: 'modal-change'
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    iProp: { // 传入要编辑的数据
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {

      ruleName: '',
      type: '42', //查区域
      areaList: [], // 区域list
      editParams: this.initParams(),
      isLoading: false
    };
  },
  watch: {
    modal: {
      // immediate: true,
      async handler(val) {
        this.editParams = this.initParams(); // 初始化输入框
        if (val) {
          this.getAreaList();  // 获取区域列表

          const { autoId } = this.iProp;

          if (autoId) return this.getPathRuleInfo(autoId);
        }
      }
    },
  },
  methods: {
    onModalChange(modal, eventName = 'on-cancel', ...options) {
      this.$emit('modal-change', !!modal);
      this.$emit(eventName, ...options);
    },
    /**
     * 区域类型
     * @param {*} type 区域类型 -1: 所有选项 
     * @param {*} param 区域子类型 -1: 子类型所有选项 , null: 过滤掉子类型
    */
    getOptions(type = -1, param = null) {
      const types = [
        { label: '线路分段限速', value: 1 },
        { label: '线路偏移', value: 2 },
      ];

      return types.filter(p => [-1, p.value].includes(type));
    },

    // 获取区域列表
    async getAreaList() {
      const result = await getTreeArea({ type: this.type, });

      if (result.flag !== 1) return this.$message.warning(result.msg);

      this.areaList = result.rows;
    },

    // 根据区域id查询区域
    async getPathRuleInfo(autoId) {
      const result = await getPathRuleInfobyId({ autoId: autoId });

      if (!result.flag) return this.$message.warning(result.msg);

      this.editParams = result.obj;
    },

    // 初始化数据
    initParams() {
      return {
        pathId: '', //区域id
        pathName: '',// 规则名称
        pathType: 1, // 规则类型
        maxSpeed: 0,//区域内限速阈值
        param: 0
      };
    },

    //关闭弹框
    handleClose() {
      this.editParams = this.initParams();
    },

    // 校验数据
    validateData() {
      const { pathId, pathName, maxSpeed } = this.editParams;
      if (!pathId) throw '请选择区域';
      if (!pathName) throw '请输入区域名称';
      if (!maxSpeed) throw '请输入区域内限速阈值';
    },

    //保存按钮
    async handleSave() {
      try {
        this.validateData();
      } catch (err) {
        return this.$message.warning(err);
      }

      const { autoId } = this.iProp;

      let action = autoId ? updatePathRule : addPathRule;
      this.isLoading = true;
      const result = await action({
        ...this.editParams,
        param:this.editParams.maxSpeed
      });
      this.isLoading = false;
      if (!result.flag) return this.$message.warning(result.msg);
      if (result.flag) this.$message.success(result.msg);
      this.onModalChange(false);
      this.$emit('on-ok');
    },

  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
  top: 10px;
  i {
    color: #fff;
    font-weight: 600;
  }
}
::v-deep .el-dialog__header {
  padding: 10px 15px;
  background: #212d3e;
  color: #fff;
}
::v-deep .el-dialog__body {
  padding: 0;
}

.content {
  width: 100%;
  padding: 20px;
  max-height: 600px;
  overflow: auto;
  &__item {
    width: 100%;
    display: flex;
    padding: 12px;
    line-height: 30px;
    & > label {
      display: block;
      width: 125px;
      text-align: right;
      font-size: 14px;
      margin: 0 15px 0 0;
    }
    .el-input {
      width: 220px;
    }
  }
}
</style>